<template>
  <owa-modal-frame
    title="Why do you need my email address?"
    :is-showing="isShowing"
    @close-modal="$emit('close-modal')"
  >
    <p
      v-if="hasArrivedFromFigma"
      class="margin-bottom-lg"
    >
      We create unique Tokens for each account that allow Figma to use Font Awesome icons. And, for Pro users, your Tokens let you use Pro icons and your custom
      icons in Figma too!
    </p>
    <p
      v-else
      class="margin-bottom-lg"
    >
      We create Kits for you to manage the icons you use in your projects. To do this, we need to create a Font Awesome account so we know which Kits are yours
      and so you can come back and manage them.
    </p>
    <p class="margin-bottom-lg">
      A Font Awesome account is free to have,
      <strong>but a valid email account is required to set up an account.</strong>
    </p>
    <p>
      You can read more about
      <site-link :to="{ name: 'privacy' }">how we use your email address</site-link>
      and what
      <site-link :to="{ name: 'tos' }">terms of service</site-link>
      come with having an account.
    </p>
  </owa-modal-frame>
</template>

<script>
  import { ModalFrameMixin } from 'app/components-wa/modals/ModalFrame'

  export default {
    name: 'ModalWhyEmail',

    mixins: [ModalFrameMixin],

    props: {
      hasArrivedFromFigma: {
        type: Boolean,
        default: false
      }
    },

    emits: ['close-modal'],
  }
</script>
